import { render, staticRenderFns } from "./DosBoxConfigControl.vue?vue&type=template&id=70561e4a&"
import script from "./DosBoxConfigControl.vue?vue&type=script&lang=js&"
export * from "./DosBoxConfigControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports